import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../service/shared/axiosBaseQuery';
import { RightUserAPIResponse } from './Rights.model';

const RightsApi = createApi({
  reducerPath: 'rights',
  tagTypes: ['rights'],
  baseQuery: axiosBaseQuery(),
  endpoints(build) {
    return {
      getMyRights: build.query<RightUserAPIResponse[], void>({
        query: () => ({
          url: `/rights/self`,
          method: 'get',
        }),
      }),
    };
  },
});

export default RightsApi;
